export const IS_SERVER = (() => typeof window === 'undefined')();

export const isGoogleBot = (() => {
  if (IS_SERVER) {
    return false;
  }
  try {
    const userAgent = navigator.userAgent || '';
    const isBot = userAgent.includes('Googlebot')
      || userAgent.includes('Google Web Preview');

    return isBot;
  } catch (error) {
    // Serverside rendering or other issues may prevent access to navigator
    return false;
  }
})();
